(() => {
  if (window.ProductDescriptionSpacing) { window.ProductDescriptionSpacing.refresh(); return; }
  function refresh() {
    document.querySelectorAll('section[id^="MainProduct-"] .section__richtext__editor p').forEach(paragraph => {
      const label = paragraph.firstElementChild;
      const isHeading = paragraph.children.length === 1 && label?.matches('strong,b') && paragraph.textContent.trim() === label.textContent.trim() && !!label.textContent.trim();
      let following = label?.nextSibling;
      while (following?.nodeType === Node.TEXT_NODE && !following.textContent.trim()) following = following.nextSibling;
      const startsSection = isHeading || (label?.matches('strong,b') && following?.nodeType === Node.ELEMENT_NODE && following.matches('br') && paragraph.firstChild === label);
      paragraph.classList.toggle('product-description-section-heading', isHeading);
      paragraph.classList.toggle('product-description-section-start', !!startsSection);
    });
  }
  window.ProductDescriptionSpacing = { refresh };
  refresh();
  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('shopify:section:load', refresh);
})();

(() => {
  async function initialise(section) {
    const picker = section.querySelector('variant-selects');
    const selects = picker && [...picker.querySelectorAll('select')];
    if (!selects || selects.length !== 3 || !selects[1].name.includes('APEX wheel specification') || picker.dataset.apexCascade) return;
    picker.dataset.apexCascade = 'loading';
    const button = section.querySelector('button[name="add"]');
    const priorDisabled = button?.disabled;
    const notice = document.createElement('p');
    notice.setAttribute('role', 'status');
    notice.textContent = 'Loading compatible wheel specifications…';
    picker.append(notice);
    selects.forEach(s => { s.disabled = true; });
    if (button) button.disabled = true;
    let variants;
    function refresh() {
      if (!variants) return;
      let candidates = variants;
      selects.forEach((select, index) => {
        const allowed = new Set(candidates.map(v => v['option' + (index + 1)]));
        for (const option of select.options) {
          option.disabled = !allowed.has(option.value);
          option.setAttribute('aria-disabled', String(option.disabled));
        }
        if (!allowed.has(select.value)) select.value = [...allowed][0] || '';
        candidates = candidates.filter(v => v['option' + (index + 1)] === select.value);
      });
      notice.textContent = '';
    }
    picker.addEventListener('change', event => {
      if (!variants) { event.stopImmediatePropagation(); return; }
      refresh();
      section.querySelector('[id^="price-"]')?.classList.add('hidden');
    }, true);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, event => {
        if (event.data.sectionId === picker.dataset.section) refresh();
      });
    }
    try {
      const all = [], seen = new Set();
      for (let page = 1; page <= 20; page++) {
        const url = new URL(picker.dataset.url + '.json', location.origin);
        url.searchParams.set('limit', '250'); url.searchParams.set('page', String(page));
        const response = await fetch(url);
        if (!response.ok) throw new Error('Wheel specifications could not be loaded');
        const product = (await response.json()).product;
        const rows = product?.variants;
        if (!Array.isArray(rows)) throw new Error('Missing wheel specifications');
        if (!rows.length) break;
        for (const row of rows) {
          if (seen.has(row.id)) throw new Error('Repeated wheel specifications page');
          seen.add(row.id); all.push(row);
        }
        if (rows.length < 250) break;
        if (page === 20) throw new Error('Too many wheel specifications');
      }
      const expected = Number(section.querySelector('[data-rada-product-variants]')?.dataset.variantCount);
      if (!all.length || (expected && all.length !== expected)) throw new Error('Incomplete wheel specifications');
      variants = all;
      selects.forEach(s => { s.disabled = false; });
      if (button) button.disabled = priorDisabled;
      picker.dataset.apexCascade = 'ready';
      let candidates = variants;
      selects.forEach((select, index) => {
        const allowed = new Set(candidates.map(v => v['option' + (index + 1)]));
        for (const option of select.options) {
          option.disabled = !allowed.has(option.value);
          option.setAttribute('aria-disabled', String(option.disabled));
        }
        candidates = candidates.filter(v => v['option' + (index + 1)] === select.value);
      });
      notice.textContent = '';
    } catch (error) {
      picker.dataset.apexCascade = 'error';
      notice.textContent = 'Wheel specifications could not be loaded. Please reload the page.';
      if (button) button.disabled = true;
      const price = section.querySelector('[id^="price-"]');
      if (price) price.classList.add('hidden');
    }
  }
  const start = () => document.querySelectorAll('section[id^="MainProduct-"]').forEach(initialise);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
